import { useEffect, useState } from "react";
import { Volume2, VolumeX } from "lucide-react";
import { Slider } from "@/components/ui/slider";
import { getVolume, getMuted, setVolume, setMuted, onAudioPrefChange } from "@/lib/audio";

export const AudioControls = () => {
  const [volume, setVol] = useState(getVolume());
  const [muted, setMute] = useState(getMuted());

  useEffect(() => onAudioPrefChange((p) => {
    setVol(p.volume);
    setMute(p.muted);
  }), []);

  const handleSlide = ([v]) => {
    setVolume(v / 100);
    if (muted && v > 0) setMuted(false);
  };

  return (
    <div
      data-testid="audio-controls"
      className="fixed bottom-4 left-4 z-50 flex items-center gap-3 rounded-full border border-stone-200 bg-white/95 backdrop-blur shadow-lg px-3.5 py-2"
    >
      <button
        data-testid="mute-toggle"
        onClick={() => setMuted(!muted)}
        aria-label={muted ? "Unmute all audio" : "Mute all audio"}
        title={muted ? "Unmute all audio" : "Mute all audio"}
        className={`inline-flex items-center justify-center h-8 w-8 rounded-full transition-colors duration-200 ${
          muted ? "bg-rose-100 text-rose-700" : "bg-emerald-50 text-emerald-800 hover:bg-emerald-100"
        }`}
      >
        {muted ? <VolumeX className="h-4 w-4" /> : <Volume2 className="h-4 w-4" />}
      </button>
      <Slider
        data-testid="volume-slider"
        value={[muted ? 0 : Math.round(volume * 100)]}
        onValueChange={handleSlide}
        max={100}
        step={1}
        aria-label="Audio volume"
        className="w-24"
      />
    </div>
  );
};
